<div class="container" id="screenWidth">
    <!--check-->
    <div id="fade"></div>
    <div id="modal">
        <img style="margin-bottom:10px;" id="loader" src="/Cache/images/icon_load.gif" /><br />
        <label><strong>Please wait while the data is processing...</strong></label>
    </div>

    <h3 *ngIf="infoData != null && !infoData.IsOnboarding" style="margin-top: 20px; margin-bottom: 10px; display: inline-block;">{{jobDetails?.PositionTitle}} (Req #: {{jobDetails?.ReqNum}})</h3>

    <button style="margin-top:25px;" (click)="cancelTask()" class="btn btn-outline-dark float-right" type="button" *ngIf="infoData != null && !infoData.IsOnboarding && !viewPDF">Cancel</button>
    <hr />
    <div *ngIf="taskCount != 0 && completedCount != taskCount && !alreadySubmitted && infoData != null && infoData?.IsOnboarding && oNtaskText != null">
        <quill-view [content]="oNtaskText"></quill-view>
    </div>
    <div *ngIf="taskCount != 0 && completedCount == taskCount && !alreadySubmitted && infoData != null && infoData?.IsOnboarding && oNtaskCompletedText != null">
        <quill-view [content]="oNtaskCompletedText"></quill-view>
    </div>
    <div *ngIf="taskCount != 0 && completedCount != taskCount && !alreadySubmitted && infoData != null && !infoData?.IsOnboarding && aTStaskText != null">
        <quill-view [content]="aTStaskText"></quill-view>
    </div>
    <div *ngIf="taskCount != 0 && completedCount == taskCount && !alreadySubmitted && infoData != null && !infoData?.IsOnboarding && aTStaskCompletedText != null">
        <quill-view [content]="aTStaskCompletedText"></quill-view>
    </div>
    <br />

    <div class="container-fluid" style="display: block;" *ngIf="isReturnFromEmployerW4Form || isReturnFromEmployerI9Form">
        <div class="alert alert-warning" style="margin: 10px; display: block;">
            <p *ngIf="isReturnFromEmployerW4Form && employerCommentW4Form != null">
                W-4 Employee's Withholding Allowance Certificate Comment : {{employerCommentW4Form}}
            </p>
            <p *ngIf="isReturnFromEmployerI9Form && employerCommentI9Form != null">
                I-9 Employment Eligibility Verification Comment : {{employerCommentI9Form}}
            </p>
        </div>
    </div>

    <div *ngIf="!viewPDF">
        <div class="card border" *ngIf="infoData != null && infoData?.IsOnboarding">
            <div class="card-header bg-light">Core Onboarding Steps</div>
            <div class="card-body">
                <div class="onboardingWizardItemContainer col-lg-10 col-md-10 offset-lg-1">
                    <a style="text-decoration: none;cursor: pointer;" (click)="updatepersonalInfo()" [ngClass]="{disableLink: alreadySubmitted}">
                        <div class="row onboardingWizardItem" [ngClass]="{onboardingWizardItemComplete: isPersonalInfoCompleted, onboardingWizardItemIncomplete: !isPersonalInfoCompleted}">
                            <div class="col-lg-9 col-md-8 col-6">
                                <span class="summaryHeadContainer">
                                    Personal Info <span style="color:red;">*</span>
                                </span>
                            </div>
                            <div class="col-lg-3 col-md-4 col-6" *ngIf="isPersonalInfoCompleted">
                                Complete!<i class="modus-icons align-bottom green">check</i>
                            </div>
                            <div class="col-lg-3 col-md-4 col-6" *ngIf="!isPersonalInfoCompleted">
                                Incomplete!<i class="modus-icons align-bottom red">close</i>
                            </div>
                            <div style="clear:both;"></div>
                        </div>
                    </a>
                </div>
                <div class="onboardingWizardItemContainer col-lg-10 col-md-10 offset-lg-1" *ngIf="includeW4 || includeI9 || includeIdentification || includeDirectDeposit || includeEmergencyContacts">
                    <div *ngFor="let task of coreList">
                        <a style="text-decoration: none;cursor: pointer;" routerLink="{{task.Url}}" [ngClass]="{disableLink: alreadySubmitted || (!isPersonalInfoCompleted && (includeW4 || includeI9 || includeIdentification || includeDirectDeposit || includeEmergencyContacts))}">
                            <div class="row onboardingWizardItem"
                                 [ngClass]="{onboardingWizardItemComplete: task.OnboardTaskDateCompleted && (isPersonalInfoCompleted),
                                 onboardingWizardItemIncomplete: !task.OnboardTaskDateCompleted && (isPersonalInfoCompleted),
                                 onboardingWizardItemDisable: (!isPersonalInfoCompleted) && (includeW4 || includeI9 || includeIdentification || includeDirectDeposit || includeEmergencyContacts),
                                 onboardingWizardItemNeedReview: isTaskNeedReview(task)}">
                                <div class="col-lg-9 col-md-8 col-6">
                                    <span class="summaryHeadContainer">
                                        {{task.OnboardTaskName}} <span style="color:red;" *ngIf="task.OnboardTaskName !== 'Direct Deposit' || (task.OnboardTaskName === 'Direct Deposit' && includeDirectDeposit == 1)">*</span>
                                    </span>
                                </div>

                                <div class="col-lg-3 col-md-4 col-6" *ngIf="isTaskNeedReview(task)">
                                    Needs Review<i class="modus-icons align-bottom red">alert</i>
                                </div>
                                <div class="col-lg-3 col-md-4 col-6" *ngIf="isTaskCompleted(task)">
                                    Complete!<i class="modus-icons align-bottom green">check</i>
                                </div>
                                <div class="col-lg-3 col-md-4 col-6" *ngIf="!task.OnboardTaskDateCompleted && (task.OnboardTaskName !== 'Direct Deposit' || (task.OnboardTaskName === 'Direct Deposit' && includeDirectDeposit != 2)) && !isTaskNeedReview(task)">
                                    Incomplete!<i class="modus-icons align-bottom red">close</i>
                                </div>
                                <div class="col-lg-3 col-md-4 col-6" *ngIf="task.OnboardTaskName === 'Direct Deposit' && includeDirectDeposit == 2">
                                    Optional!
                                </div>

                                <div style="clear:both;"></div>
                            </div>
                        </a>
                        <br />
                    </div>
                </div>
            </div>
        </div>
        <br />
        <div class="card border" *ngIf="infoData != null">
            <div class="card-header bg-light" *ngIf="!infoData.IsOnboarding">General Application Questions</div>
            <div class="card-header bg-light" *ngIf="infoData.IsOnboarding">Tasks To Complete</div>
            <div class="card-body">
                <div class="onboardingWizardItemContainer col-lg-10 col-md-10 offset-lg-1" *ngIf="infoData != null && !infoData?.IsOnboarding && finishLoading">
                    <div>
                        <a style="text-decoration: none;cursor: pointer;" (click)="updatepersonalInfo()" [ngClass]="{disableLink: alreadySubmitted}">
                            <div class="row onboardingWizardItem" [ngClass]="{onboardingWizardItemComplete: isPersonalInfoCompleted, onboardingWizardItemIncomplete: !isPersonalInfoCompleted}">
                                <div class="col-lg-9 col-md-8 col-6">
                                    <span class="summaryHeadContainer">
                                        Personal Info <span style="color:red;">*</span>
                                    </span>
                                </div>
                                <div class="col-lg-3 col-md-4 col-6" *ngIf="isPersonalInfoCompleted">
                                    Complete!<i class="modus-icons align-bottom green">check</i>
                                </div>
                                <div class="col-lg-3 col-md-4 col-6" *ngIf="!isPersonalInfoCompleted">
                                    Incomplete!<i class="modus-icons align-bottom red">close</i>
                                </div>

                                <div style="clear:both;"></div>
                            </div>
                        </a>
                    </div>
                    <div *ngIf="includeIdentification" style="margin-top:20px;">
                        <a routerLink="{{coreList[0].Url}}" [ngClass]="{disableLink: alreadySubmitted || (!isPersonalInfoCompleted)}">
                            <div class="row onboardingWizardItem"
                                 [ngClass]="{onboardingWizardItemComplete: coreList[0].OnboardTaskDateCompleted && (isPersonalInfoCompleted),
                                                 onboardingWizardItemIncomplete: !coreList[0].OnboardTaskDateCompleted && (isPersonalInfoCompleted),
                                                 onboardingWizardItemDisable: !isPersonalInfoCompleted}">
                                <div class="col-lg-9 col-md-8 col-6">
                                    <span class="summaryHeadContainer">
                                        {{coreList[0].OnboardTaskName}} <span style="color:red;">*</span>
                                    </span>
                                </div>

                                <div class="col-lg-3 col-md-4 col-6" *ngIf="coreList[0].OnboardTaskDateCompleted">
                                    Complete!<i class="modus-icons align-bottom green">check</i>
                                </div>
                                <div class="col-lg-3 col-md-4 col-6" *ngIf="!coreList[0].OnboardTaskDateCompleted">
                                    Incomplete!<i class="modus-icons align-bottom red">close</i>
                                </div>

                                <div style="clear:both;"></div>
                            </div>
                        </a>
                    </div>
                </div>
                <div class="onboardingWizardItemContainer col-lg-10 col-md-10 offset-lg-1" *ngFor="let task of tasks">
                    <div>
                        <a style="text-decoration: none;cursor: pointer;" routerLink="{{task.Url}}" [ngClass]="{disableLink: alreadySubmitted || (!isPersonalInfoCompleted)}">
                            <div class="row onboardingWizardItem"
                                 [ngClass]="{onboardingWizardItemComplete: task.OnboardTaskDateCompleted != null && isPersonalInfoCompleted,
                                 onboardingWizardItemIncomplete: task.OnboardTaskDateCompleted == null && isPersonalInfoCompleted,
                                 onboardingWizardItemDisable: !isPersonalInfoCompleted}">
                                <div class="col-lg-9 col-md-8 col-6">
                                    <span class="summaryHeadContainer">
                                        {{task.OnboardTaskName}}<span *ngIf="task.OnboardTaskIsRequired" style="color:red;">*</span>
                                    </span>
                                </div>

                                <div class="col-lg-3 col-md-4 col-6" *ngIf="task.OnboardTaskDateCompleted != null">
                                    Complete!<i class="modus-icons align-bottom green">check</i>
                                </div>
                                <div class="col-lg-3 col-md-4 col-6" *ngIf="task.OnboardTaskDateCompleted == null">
                                    Incomplete!<i class="modus-icons align-bottom red">close</i>
                                </div>

                                <div style="clear:both;"></div>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <br />
        <div class="card border" *ngIf="questionList?.length > 0">
            <div class="card-header bg-light">
                Additional Questions
                <span *ngIf="lastSave.status === 'success' && lastSave.time != null" class="badge badge-success default" [ngClass]="{fade: formData.labelFade}" style="margin-left:25px;">Save Successful - {{lastSave.time}}</span>
                <span *ngIf="lastSave.status === 'danger' && lastSave.time != null" class="badge badge-danger default" [ngClass]="{fade: formData.labelFade}" style="margin-left:25px;">Save Fail - {{lastSave.time}}</span>
            </div>
            <div class="card-body" style="padding-bottom: 0px; padding-top: 0px; padding-right: 15px; padding-left: 15px; ">
                <div *ngFor="let data of questionList; let $index = index;">
                    <div [ngClass]="{backColor: $index%2==1}" class="row">
                        <div class="col-lg-6" style="margin-top:10px;">
                            {{data.QuestionText}}
                        </div>
                        <div class="col-lg-6" style="margin-bottom:5px;margin-top:5px;">
                            <input [(ngModel)]="data.AnswerText" class="form-control" type="text" (blur)="saveAnswer(data)" [disabled]="alreadySubmitted" maxlength="500" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <br />
        <div class="card border" *ngIf="maxAttachments != null && maxAttachments != 0">
            <div class="card-header bg-light">Attachments (maximum of {{maxAttachments}} files)</div>
            <div class="card-body">
                <div class="row">
                    <div class="col-lg-6" *ngIf="!alreadySubmitted">
                        <label *ngIf="newFiles.length > 0"><strong>Attachments pending save</strong></label>
                        <br *ngIf="newFiles.length > 0" />
                        <div *ngFor="let file of newFiles" style="margin-top: 20px">
                            {{file.Filename}}
                            <div style="padding-left:15px;margin-top:5px;">
                                <div class="progress progress-striped active" style="width:300px;" *ngIf="file.Progress > 0">
                                    <div class="progress-bar" role="progressbar" [ngStyle]="{ 'width': file.Progress + '%' }">{{file.Progress}}%</div>
                                </div>
                            </div>
                        </div>
                        <div ngfDrop multiple="1" selectable="1" [(files)]="formData.fileDrop" [(validDrag)]="validComboDrag" [style.width.px]="attachmentWidth"
                             accept=".pdf,.jpg,.jpeg,.gif,.tif,.tiff,.png,.bmp,.doc,.docx,.xls,.xlsx,.ppt,.pps,.pptx,.ppsx,.sldx"
                             [class.invalid-drag]="validComboDrag===false" [class.valid-drag]="validComboDrag"
                             [(dragFiles)]="dragFiles" class="drop-box" (filesChange)="upload()" [ngfFixOrientation]="false"
                             *ngIf="maxAttachments != 0 && maxAttachments > savedFiles.length">
                            <div class="row">
                                <div class="col-3">
                                    <span style="font-size:35px;margin-top:5px;" class="oi oi-paperclip" *ngIf="attachmentWidth == 500"></span>
                                    <span style="font-size:35px;margin-top:5px;margin-left:15px;" class="oi oi-paperclip" *ngIf="attachmentWidth < 500"></span>
                                </div>
                                <div class="col-8" style="font-size:16px; margin-top:10px;" *ngIf="attachmentWidth == 500">
                                    <span>Drag and drop or click to attach</span>
                                </div>
                                <div class="col-8" style="font-size:16px;" *ngIf="attachmentWidth < 500">
                                    <span>Drag and drop or click to attach</span>
                                </div>
                            </div>
                        </div>
                        <span [ngClass]="mobileMode ? 'text-break' : 'text-nowrap'">Supported file formats: .pdf, .jpg, .gif, .tif, .png, .bmp, .doc(x), .xls(x), .ppt(x), .pps(x), .sldx</span>
                    </div>
                    <div class="col-lg-6">
                        <div *ngFor="let file of savedFiles" style="margin-bottom: 15px;">
                            <a href="/Employee/GetFileAttachmentData?fileAttachmentID={{file.FileAttachmentID}}"> {{file.AttachmentFileName}}</a>
                            <a class="button-link" (click)="deleteAttachment(file)" *ngIf="!alreadySubmitted">
                                <span style="cursor:pointer;color:red;">(remove)</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <br />
        <div class="card border">
            <div class="card-header bg-light" *ngIf="infoData != null && infoData.IsOnboarding">Finalize and Submit</div>
            <div class="card-header bg-light" *ngIf="infoData != null && !infoData.IsOnboarding">Complete your submission</div>
            <div class="card-body">
                <div class="onboardingWizardItemContainer col-lg-10 col-md-10  offset-lg-1">
                    <div>
                        <div *ngIf="!alreadySubmitted">
                            <div *ngIf="customSubmitText != null">
                                <quill-view [content]="customSubmitText"></quill-view>
                            </div>
                            <button type="button" class="btn btn-success" (click)="submitTask()" [disabled]="incompleteCount != 0 || ((!isPersonalInfoCompleted&& !infoData?.IsOnboarding) && (includeW4 || includeI9)) || formData.fileDrop?.length > 0" style="color:white;" *ngIf="finishLoading && infoData?.IsOnboarding">Submit</button>
                            <button type="button" class="btn btn-primary" (click)="downloadRDL()" [disabled]="incompleteCount != 0" style="color:white;" *ngIf="finishLoading && !infoData?.IsOnboarding && !showAttachmentWarning">Review Application</button>
                            <button type="button" class="btn btn-success" (click)="submitTaskCheck()" [disabled]="incompleteCount != 0 || formData.fileDrop?.length > 0" style="color:white;" *ngIf="finishLoading && !infoData?.IsOnboarding && !showAttachmentWarning">Submit</button>

                            <span style="margin-left:5px;" *ngIf="infoData != null && infoData.IsOnboarding">When you have completed the above tasks, click Submit to finish your process.</span>
                            <span style="margin-left:5px;color:red;font-weight: bold;" *ngIf="showAttachmentWarning && maxAttachments != 0">Submit application without attachments?</span>
                            <button type="button" class="btn btn-success" (click)="submitTask()" [disabled]="incompleteCount != 0" style="color:white;" *ngIf="finishLoading && !infoData?.IsOnboarding && showAttachmentWarning">Confirm</button>
                            <button type="button" class="btn btn-outline-dark" (click)="cancelSubmit()" [disabled]="incompleteCount != 0" style="color:black;" *ngIf="finishLoading && !infoData?.IsOnboarding && showAttachmentWarning">Cancel</button>
                        </div>
                        <div class="row onboardingWizardItem" style="display:flex;" *ngIf="alreadySubmitted"
                             [ngClass]="{onboardingWizardItemComplete: alreadySubmitted, onboardingWizardItemIncomplete: incompleteCount > 0}">
                            <div class="col-lg-9" *ngIf="incompleteCount == 0">You have already submitted.</div>
                            <div class="col-lg-3" *ngIf="incompleteCount == 0">
                                Complete!<i class="modus-icons align-bottom green">check</i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div [hidden]="!viewPDF">
        <div class="card-body bg-light border" style="display: block;">
            <button type="button" class="btn btn-outline-dark" (click)="quitViewPDF()"><span><i class="modus-icons align-bottom">chevron_left</i></span> Back</button>
            <button type="button" class="btn btn-success float-right" (click)="submitTaskCheck()" [disabled]="incompleteCount != 0" *ngIf="!showAttachmentWarning" style="color:white;">Submit Application</button>
            <button type="button" class="btn btn-outline-dark float-right" (click)="cancelSubmit()" [disabled]="incompleteCount != 0" style="color:black;" *ngIf="finishLoading && !infoData?.IsOnboarding && showAttachmentWarning">Cancel</button>
            <button type="button" class="btn btn-success float-right" (click)="submitTask()" [disabled]="incompleteCount != 0" style="color:white;margin-right:5px;" *ngIf="finishLoading && !infoData?.IsOnboarding && showAttachmentWarning">Confirm</button>
            <span style="margin-left:5px;color:red;font-weight: bold;" *ngIf="showAttachmentWarning && maxAttachments != 0">Submit application without attachments?</span>
        </div>
        <ejs-pdfviewer id="pdfViewer"
                       [resourceUrl]='pdfResource'
                       [documentPath]=''
                       [enableFormFields]='false'
                       [enableFormDesignerToolbar]='false'
                       [enableDownload]="true"
                       [enablePrint]="true"
                       [printMode]="printMode"
                       [isSignatureEditable]="false"
                       style="height:640px;display:block">
        </ejs-pdfviewer>
    </div>
</div>